
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as index3_8cjQxO7r4VrqXlviE2kKFnxSWLWy_45_X7eyy0XkHNEMeta } from "/app/pages/faqs/index.vue?macro=true";
import { default as _91_91id_93_93fuVuwsuDJFYqZcWjU2Lr8xViCpxqLjMDShoO61qmhgkMeta } from "/app/pages/ref/[[id]].vue?macro=true";
import { default as indexsziV31bRWzCkX_45YudaBOdqrwcbympIP9GPi2Nu0StJUMeta } from "/app/pages/about/index.vue?macro=true";
import { default as indexgIHaC0fdW2BGHm1KPXppFjW1YknpFdYO_LTaS3pYtQQMeta } from "/app/pages/terms/index.vue?macro=true";
import { default as indexfOT7GlrsYLimatDwJCeBdHbax_458BjQKOZ_u4twaT49IMeta } from "/app/pages/cookies/index.vue?macro=true";
import { default as index5t_4515327WHlreIdVbmH6bKIHubwoazT9y1jlNOUAVesMeta } from "/app/pages/privacy/index.vue?macro=true";
import { default as indexo2_aOKOa6D1FHFGPVtcTzIIV5UU4oyTg8ow_45uVzF3EgMeta } from "/app/pages/contacts/index.vue?macro=true";
import { default as _91_91id_93_93Dj0axbxME0hG0wfPyKpaHrzpK4OO7KCYVVYoDSbft_45EMeta } from "/app/pages/forms/sign/[[id]].vue?macro=true";
import { default as _91_91id_93_93fBuwRFGvFP6_8XK9QSoZGUJSAkwCgTkU4xljKCsF9gAMeta } from "/app/pages/forms/quote/[[id]].vue?macro=true";
import { default as _91_91id_93_93gbrnLt6v_ht0iMML6fSgZCzehRqza3gApBgG_NV4F3IMeta } from "/app/pages/forms/payment/[[id]].vue?macro=true";
import { default as _91_91id_93_93BspzTowwf_8u8C4osvk7RpWTaAZa1zatt_ZtgD9iqOQMeta } from "/app/pages/forms/application/[[id]].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/app/pages/faqs/index.vue")
  },
  {
    name: "ref-id",
    path: "/ref/:id?",
    component: () => import("/app/pages/ref/[[id]].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms/index.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/app/pages/cookies/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/app/pages/contacts/index.vue")
  },
  {
    name: "forms-sign-id",
    path: "/forms/sign/:id?",
    component: () => import("/app/pages/forms/sign/[[id]].vue")
  },
  {
    name: "forms-quote-id",
    path: "/forms/quote/:id?",
    component: () => import("/app/pages/forms/quote/[[id]].vue")
  },
  {
    name: "forms-payment-id",
    path: "/forms/payment/:id?",
    component: () => import("/app/pages/forms/payment/[[id]].vue")
  },
  {
    name: "forms-application-id",
    path: "/forms/application/:id?",
    component: () => import("/app/pages/forms/application/[[id]].vue")
  }
]